var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-alert',{attrs:{"show":_vm.dismissCountDown,"dismissible":_vm.dismissible,"fade":"","variant":_vm.variant},on:{"dismissed":function($event){_vm.dismissCountDown=0}}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.alertContent)}}),_vm._v(" "),_vm._t("content")],2)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cce3d25c","hasScoped":false,"optionsId":"0","buble":{"objectAssign":"Object.assign","transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Form/FITAlert.vue
// module id = null
// module chunks = 